import { render, staticRenderFns } from "./BasicExamFindingForm.vue?vue&type=template&id=36a81848&"
import script from "./BasicExamFindingForm.vue?vue&type=script&lang=js&"
export * from "./BasicExamFindingForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicExamFindingForm.vue?vue&type=style&index=0&id=36a81848&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports